import React from "react"
import Navbar from "../../Common/Components/Navbar"
import Footer from "../../Common/Components/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import ActivityLogComp  from "./Component/ActivityLogComp"

const ActivityLog =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ActivityLogComp />
        </div>
        <Footer />
        </>
    )
}

export default ActivityLog